import { icons } from 'common'
import { css } from 'styled-components'
import { fontsCss } from 'themes/css/fontsCss'
import { hintCss } from 'themes/css/hintCss'
import { keyframesCss } from 'themes/css/keyframes'

export const commonCSS = css`
  body,
  html {
    height: 100%;
    overflow: hidden;
  }

  summary::-webkit-details-marker {
    display: none !important;
  }

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    text-rendering: geometricPrecision;
    line-height: 100%;
    font-family: 'Inter', sans-serif;
    font-weight: 400;
    color: #fff;
    /* transition: all 0.5s; */
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p {
    margin: 0;
  }

  body {
    font-size: 1rem;
    font-weight: 400;
    background: var(--site-background);
    background-attachment: fixed;
    color: #fff;
    min-height: 100%;
    animation: bugfix infinite 1s;
    -webkit-animation: bugfix infinite 1s;
  }

  button {
    outline: none;
    border: none;
    background: var(--primary-button-background);
    text-decoration: none;
    cursor: pointer;
    /* -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s; */
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 100%;
    border-radius: 10px;
  }
  button:hover {
    background: var(--primary-button-hover-background);
  }

  a {
    color: var(--primary-text-color);
    text-decoration: none;
    text-decoration-color: rgba(255, 255, 255, 0.4);
  }
  a:hover {
    color: var(--primary-text-color);
  }

  ul,
  li {
    list-style: none;
  }

  #root {
    overflow: hidden;
    height: 100%;
  }

  fieldset {
    outline: 0;
    border: 0;
  }

  input[type='text'],
  input[type='tel'] {
    border: 0;
    outline: 0;
  }

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:vertical,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: hsla(0, 0%, 100%, 0.5);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }
  @-moz-document url-prefix() {
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    *:hover ::-webkit-scrollbar {
      opacity: 1;
    }
    ::-webkit-scrollbar-track,
    ::-webkit-scrollbar-track-piece {
      background-color: transparent;
      border-radius: 20px;
      opacity: 0;
    }
    ::-webkit-scrollbar-thumb,
    ::-webkit-scrollbar-thumb:vertical,
    ::-webkit-scrollbar-thumb:horizontal {
      background-color: hsla(0, 0%, 100%, 0.5);
      border-radius: 20px;
    }
    ::-webkit-scrollbar-corner {
      background: rgba(0, 0, 0, 0);
    }
  }

  .info_asset_icon {
    background: hsla(0, 0%, 100%, 0.1) url(${icons.info_icon}) center center / auto 10px no-repeat;
    padding: 10px;
    margin: 0 5px;
    border-radius: 6px;
    display: flex;
    width: fit-content;
    height: fit-content;
  }
  .info_tooltip_icon,
  .info_icon {
    background: hsla(0, 0%, 100%, 0.1) url(${icons.info_icon}) center center / auto 10px no-repeat;
    padding: 10px;
    margin: 0 0 0 0;
    border-radius: 6px;
    display: flex;
    width: fit-content;
    height: fit-content;
  }

  .info_asset_icon:hover,
  .info_tooltip_icon:hover,
  .info_icon:hover {
    background-color: hsla(0, 0%, 100%, 0.2);
  }

  .grecaptcha-badge {
    opacity: 0;
  }

  .new_icon_badge {
    -webkit-mask: url(${icons.new_icon_game}) center center / 30px auto no-repeat;
    mask: url(${icons.new_icon_game}) center center / 30px auto no-repeat;
    width: 30px;
    height: 16px;
    margin: -1px 0 0 5px;
  }

  .new_icon-green {
    background: url(${icons.new_icon_green}) center center / 30px auto no-repeat;
    width: 30px;
    height: 16px;
    margin: -1px 0 0 5px;
  }
  .new_icon-green {
    background: url(${icons.new_icon_green}) center center / 30px auto no-repeat;
    width: 30px;
    height: 16px;
    margin: -1px 0 0 5px;
  }
  .new_icon-yellow {
    background: url(${icons.new_icon_yellow}) center center / 30px auto no-repeat;
    width: 30px;
    height: 16px;
    margin: -1px 0 0 5px;
  }
  .new_icon-purple {
    background: url(${icons.new_icon_purple}) center center / 30px auto no-repeat;
    width: 30px;
    height: 16px;
    margin: -1px 0 0 5px;
  }
  .beta_icon-ai_indexes {
    mask: url(${icons.beta_icon}) center center / 30px auto no-repeat;
    width: 30px;
    height: 16px;
    margin: -1px 0 0 5px;
    background: #de0ecd;
  }

  ${hintCss}
  ${fontsCss}
  ${keyframesCss}
`
